export const createSuccessToast = {
  title:
    '$t(tracker:displayKind, {"context": "{{context}}" }) has been successfully added.',
};
